import {useMutation} from 'react-query';
import {apiEndpoints} from '../constants/ApiConstants';
import {IShopDetails} from '../types/UserAuth.types';
import {auth} from '../ApiClient';
import {getPosSessionId} from './useGetPosSessionIdMutation';
import {findCurrentShop} from "./findCurrentShop";

export function useGetShopSelectionMutation() {
  return useMutation<IShopDetails, Error>(getShopSelection);
}

export async function getShopSelection(): Promise<IShopDetails> {
  const options = {
    headers: {'content-type': 'application/x-www-form-urlencoded'},
  };
  const response = (await auth.post(`${apiEndpoints.shopSelection}`, {}, options));
  const currentStore = findCurrentShop(response?.data?.shopDetailsList);
  if (currentStore) {
    localStorage.setItem('shopId', currentStore?.shopId);
    await getPosSessionId();
  }

  return response;
}
